var _style, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEuro01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24.42 24.39",
    style: {
      enableBackground: "new 0 0 24.42 24.39"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#2D3577;}\n\t.st1{fill:#F8E90C;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.49,0.21L14.49,0.21c-0.1-0.03-0.2-0.04-0.3-0.06c-0.11-0.02-0.23-0.03-0.35-0.04 c-0.1-0.01-0.2-0.04-0.3-0.05h-0.09c-0.11-0.01-0.22-0.03-0.33-0.04C13.01,0.01,12.89,0.01,12.77,0h-0.26h-0.86 c-0.21,0.01-0.42,0.04-0.63,0.06h-0.14c-0.07,0.01-0.14,0.02-0.21,0.03c-0.18,0.02-0.36,0.05-0.55,0.09 c-0.2,0.03-0.4,0.07-0.6,0.12C9.34,0.33,9.17,0.38,8.99,0.43C8.8,0.48,8.61,0.54,8.42,0.6C8.25,0.65,8.08,0.71,7.91,0.78 C7.72,0.85,7.54,0.92,7.36,1C7.29,1.03,7.21,1.06,7.13,1.09C6.97,1.16,6.81,1.24,6.66,1.32C6.63,1.34,6.6,1.35,6.57,1.36 C6.56,1.37,6.55,1.38,6.54,1.38C6.3,1.51,6.08,1.64,5.85,1.78C5.78,1.83,5.7,1.86,5.64,1.91C5.34,2.1,5.05,2.3,4.78,2.51 c0,0-0.01,0.01-0.01,0.01C4.4,2.8,4.06,3.11,3.73,3.43C3.69,3.47,3.64,3.5,3.61,3.53C3.53,3.61,3.47,3.69,3.4,3.76 c-0.14,0.15-0.28,0.3-0.41,0.45C2.87,4.34,2.77,4.47,2.66,4.6C2.53,4.77,2.41,4.93,2.28,5.1c-0.05,0.07-0.1,0.13-0.15,0.2 C2.1,5.35,2.07,5.41,2.03,5.47c-0.19,0.29-0.37,0.59-0.54,0.9C1.46,6.43,1.41,6.49,1.38,6.55C1.36,6.58,1.35,6.61,1.34,6.64 C1.28,6.76,1.23,6.88,1.17,6.99c-0.07,0.14-0.14,0.28-0.2,0.42C0.93,7.5,0.9,7.59,0.86,7.68C0.85,7.72,0.84,7.75,0.83,7.78 C0.82,7.79,0.81,7.81,0.81,7.83l0,0C0.29,9.18,0,10.66,0,12.2c0,6.55,5.16,11.9,11.65,12.2h1.13c6.48-0.29,11.65-5.64,11.65-12.2 C24.42,6.23,20.14,1.28,14.49,0.21z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "12.2,17.77 12.46,18.53 13.24,18.53 12.68,18.94 12.84,19.76 12.2,19.29 11.57,19.74 11.72,18.94  11.18,18.52 11.95,18.52  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "12.2,4.64 12.46,5.39 13.24,5.39 12.68,5.81 12.84,6.62 12.2,6.16 11.57,6.61 11.72,5.81  11.18,5.39 11.95,5.39  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "15.37,5.48 15.62,6.24 16.4,6.24 15.85,6.66 16,7.47 15.37,7.01 14.73,7.45 14.88,6.66 14.34,6.23  15.12,6.23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "8.89,5.48 9.14,6.24 9.92,6.24 9.37,6.66 9.52,7.47 8.89,7.01 8.25,7.45 8.41,6.66 7.86,6.23  8.64,6.23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "15.37,16.88 15.62,17.64 16.4,17.64 15.85,18.06 16,18.87 15.37,18.41 14.73,18.86 14.88,18.06  14.34,17.64 15.12,17.64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "8.89,16.88 9.14,17.64 9.92,17.64 9.37,18.06 9.52,18.87 8.89,18.41 8.25,18.86 8.41,18.06  7.86,17.64 8.64,17.64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.46,7.96 6.72,8.72 7.5,8.72 6.95,9.13 7.1,9.95 6.46,9.48 5.83,9.93 5.98,9.13 5.44,8.71  6.21,8.71  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "17.87,7.96 18.12,8.72 18.9,8.72 18.35,9.13 18.5,9.95 17.87,9.48 17.23,9.93 17.39,9.13  16.84,8.71 17.62,8.71  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.46,14.52 6.72,15.27 7.5,15.27 6.95,15.69 7.1,16.5 6.46,16.04 5.83,16.49 5.98,15.69 5.44,15.27  6.21,15.27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "17.87,14.52 18.12,15.27 18.9,15.27 18.35,15.69 18.5,16.5 17.87,16.04 17.23,16.49 17.39,15.69  16.84,15.27 17.62,15.27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "5.71,11.21 5.97,11.97 6.74,11.97 6.19,12.39 6.34,13.2 5.71,12.74 5.08,13.19 5.23,12.39  4.68,11.97 5.46,11.97  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "18.7,11.21 18.96,11.97 19.74,11.97 19.18,12.39 19.34,13.2 18.7,12.74 18.07,13.19 18.22,12.39  17.67,11.97 18.45,11.97  "
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuro01);
export default __webpack_public_path__ + "static/media/euro-01.b6e368f733d5051c6a693d2bdf223a92.svg";
export { ForwardRef as ReactComponent };